/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */


import BaseIdObject from "@shared/BaseIdObject";


export default class TagItem extends BaseIdObject{

	title: string = ""
	color: string = "#409EFF"
	description: string = ""
	usageCounter: number = 0


	constructor(title: string = null, description: string = null) {
		super();
		this.title = title;
		this.description = description;
	}

	indexOf(){
		return -1
	}

	backgroundColor(){
		if(this.color){
			return this.color + "33"
		}
	}
	borderColor(){
		if(this.color){
			return this.color + "88"
		}
	}
	textColor(){
		if(this.color){
			return this.color + "FF"
		}
	}

}

